import { atomWithStorage } from 'jotai/utils';
import { UserTokenPayload } from '../types';

export interface AuthState {
  user: UserTokenPayload | null;
  accessToken?: string | null;
  refreshToken?: string | null;
}

export const authAtom = atomWithStorage<AuthState | undefined>('auth', undefined);
